import React from 'react';

import {
  shallowEqual,
  useSelector,
} from 'react-redux';
import {
  getStatus,
} from 'redux-resource';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  Spinner,
  NotFound,
  ContentWrapper,
} from 'web-components';

import {
  Flex,
  TextBold,
} from 'web-styled';

import ProItems from './ProItems';
import ClientItems from './ClientItems';
import * as S from './styled';

const mapState = state => ({
  isPro: coreSelectors.getProfile('is_pro')(state),
  readStatus: getStatus(
    state,
    [
      'products.requests.fetchProducts.status',
      'productPlans.requests.fetchProductPlans.status',
    ],
    true,
  ),
  updateStatus: getStatus(
    state,
    [
      'paymentIntents.requests.buyProduct.status',
      'paymentIntents.requests.finishBuy.status',
      'paymentMethods.requests.create.status',
      'paymentMethods.requests.delete.status',
      'paymentMethods.requests.setDefault.status',
    ],
  ),
});

const MarketplacePage = () => {
  const {
    isPro,
    readStatus,
    updateStatus,
  } = useSelector(mapState, shallowEqual);

  return (
    <ContentWrapper
      header={(
        <Flex
          fillSpace
          column
          width="100%"
          margin="0 -15px"
        >
          <S.Header>
            <TextBold
              color="#fff"
              size="2.15em"
            >
              Marketplace
            </TextBold>
          </S.Header>
        </Flex>
      )}
    >
      {readStatus.succeeded && (
        <Flex
          width="100%"
          padding="30px"
          spacing={30}
        >
          {isPro ? (
            <ProItems />
          ) : (
            <ClientItems />
          )}
        </Flex>
      )}

      {readStatus.pending && (
        <Spinner message="Loading Products..." />
      )}

      {readStatus.failed && (
        <NotFound title="Something went wrong" />
      )}

      {updateStatus.pending && (
        <Spinner over />
      )}
    </ContentWrapper>
  );
};

export default MarketplacePage;
